/* eslint-disable */
import { TaskQueue } from 'tools';
// 全局地址任务队列
export const globalAddressTaskQueue = new TaskQueue(1);
// 全局地址json
export let globalAddressJson = null;
// 设置全局地址json
export const setGlobalAddressJson = function(data){
    globalAddressJson = data;
};



// WEBPACK FOOTER //
// ./src/libs/TaskQueue.js